import React, { useState, createContext, useEffect, useCallback } from 'react';
import data from '../assets/data.json';
import {
  api,
  // apiNotSensedia
} from '../middlewares';
import { translateHome } from '../Utils/translateFunctions';

import changeImageUrl from '../Utils/changeUrl';
import { datadogRum } from '@datadog/browser-rum';
import { getUrlFotoS3 } from './endPointsNotificacoes';
// import { ContextSolicitacoes } from "../services/solicitacoes";

const ContextGetData = createContext();

function GetData({ children }) {
  // um empreendimento tem imóveis
  // imagens são do empreendimento
  // status da obra é do empreendimento
  // todo carregamento da HOME depende do imóvel selecionado
  // cada imóvel tem um id do empreendimento, através deste ID que são selecionadas as imagens e status
  const [imagensEmpreendimento, setImagensEmpreendimento] = useState([]);
  const [dataUltimaAtualizacaoFotos, setDataUltimaAtualizacaoFotos] =
    useState('');
  const [dataFotoTirada, setDataFotoTirada] = useState('');
  const [statusObra, setStatusObra] = useState([]);
  const [imoveis, setImoveis] = useState([]);
  const [idConta, setIdConta] = useState('');
  const [idSalesForce, setIdSalesForce] = useState('');
  const [arrayTermos, setArrayTermos] = useState([]);
  const [contratosRenegociacao, setContratosRenegociacao] = useState([]);
  const [home, setHome] = useState([]);
  const [userData, setUserData] = useState({});

  const handleUriOrigem = (imagens) => {
    return imagens.map((img) => {
      if (!img.idAws) {
        return {
          ...img,
          Uri: changeImageUrl(img?.Uri),
        };
      }

      if (!img?.Uri) {
        img.Uri = '#';
      }

      return img;
    });
  };

  useEffect(() => {
    setImoveis([]);
  }, []);

  useEffect(() => {
    datadogRum.setUser(userData);
  }, [userData]);

  useEffect(() => {
    buscaDados();
  }, [home]);

  async function importDataHome() {
    let homeData = '';
    let tempResult = '';

    try {
      setImoveis([]);

      tempResult = await api.get('Home/Conta');

      homeData = translateHome(tempResult.data);

      setArrayTermos(homeData.aceiteTermos);

      setContratosRenegociacao(homeData.contratosRenegociacao);

      setIdConta(homeData.id);

      setIdSalesForce(homeData.accountIdSalesforce);

      localStorage.setItem('accid', homeData.accountIdSalesforce);

      setHome(homeData.imoveis);

      setUserData({
        nome: homeData.nome,
        email: homeData.email,
        cpfCnpj: homeData.cpfCnpj,
        id: homeData.id,
      });

      return homeData;
    } catch (error) {
      return error.request;
    }
  }

  // função que faz um get na home para confirmar o usuário, impossibilitando que o mesmo faça o primeiro acesso duas vezes
  async function softImportDataHome() {
    try {
      await api.get('Home/Conta');
      // await apiNotSensedia.get("home/getclient");

      localStorage.removeItem('tempSensToken');
    } catch (error) {
      return [];
    }
  }

  //função para filtrar para os dados da home quando o usuário selecionar o imóvel da lista de imóveis
  async function filtraImovel(id, arrayImoveis) {
    let resultado = await Promise.resolve(
      arrayImoveis.filter(
        (imovel) => imovel.empreendimento.empreendimentoIdSalesForce == id
      )
    );

    return resultado;
  }

  async function setArrayImoveis(dataArray) {
    let arrayImoveis = [];
    for (let i = 0; i < dataArray.length; i++) {
      arrayImoveis[i] = {
        nome: dataArray[i].NomeImovel,
        id: dataArray[i].empreendimentoId,
        tipo: dataArray[i].empreendimento.holding.nome,
        assetId: dataArray[i].empreendimento.empreendimentoIdSalesForce,
        ...dataArray[i],
      };
    }
    setImoveis(arrayImoveis);
    setLocalStorage(arrayImoveis);
    return arrayImoveis;
  }

  async function setLocalStorage(array) {
    localStorage.setItem('imoveis', JSON.stringify(array));
  }

  const loadHomeInicial = async () => {
    const homeData = await importDataHome();
    await atualizaAgendamentosAbertos();

    return homeData;
  };

  const atualizaAgendamentosAbertos = async () => {
    let qtdAgendamentos = '';
    qtdAgendamentos = await api.get('Solicitacao/AgendamentosAbertos');

    sessionStorage.setItem('qtdAgdm', qtdAgendamentos.data.length);
  };

  const montaStatusDaObra = (imovelExibido) => {
    setStatusObra({
      fundacao:
        Math.trunc(parseInt(imovelExibido[0].empreendimento.fundacao), 10) || 0,
      estrutura:
        Math.trunc(parseInt(imovelExibido[0].empreendimento.estrutura), 10) ||
        0,
      acabamento:
        Math.trunc(parseInt(imovelExibido[0].empreendimento.acabamento), 10) ||
        0,
      alvenaria:
        Math.trunc(parseInt(imovelExibido[0].empreendimento.alvenaria), 10) ||
        0,
      area_externa:
        Math.trunc(parseInt(imovelExibido[0].empreendimento.areaExterna), 10) ||
        0,
      evolucao_obra:
        Math.trunc(
          parseInt(imovelExibido[0].empreendimento.totalAndamento),
          10
        ) || 0,
      instalacoes:
        Math.trunc(parseInt(imovelExibido[0].empreendimento.instalacao), 10) ||
        0,
    });
  };

  // função IMPORTANTÍSSIMA, caso o empreendimento não tiver imagens é setado um array de imagens vazio
  const imagensDaObra = (imovelImagens) => {
    if (imovelImagens == undefined || imovelImagens == null) {
      setImagensEmpreendimento([]);
    } else {
      const imagesComUrlTratadas = handleUriOrigem(imovelImagens);

      if (imagesComUrlTratadas.length === 0) {
        setImagensEmpreendimento([]);
        return;
      }

      setImagensEmpreendimento(imagesComUrlTratadas);
    }
  };

  const buscaDados = async (idimovelselecionado) => {
    let imovelFiltrado = '';

    let imovelExibido = '';

    // função importante, ela registra a lista de imóveis
    // passa-se via contexto e pelo localstorage para casos de demora no setItem do localStorage
    await setArrayImoveis(home);

    //função abaixo é utilizada para fazer o filtro dos dados na home, somente será executada após o usuário selecionar um dos empreendimentos.
    // em default o empreendimento a ser carregado será o de posição 0 - ZERO do array de imóveis
    if (
      (idimovelselecionado != '' || idimovelselecionado != undefined) &&
      home.length > 0
    ) {
      await filtraImovel(idimovelselecionado, home).then(
        (response) => (imovelFiltrado = response)
      );
    }

    // verificação para exibir o imóvel
    // se imóvel filtrado for diferente de vazio, quer dizer que o usuário selecionou um imóvel
    // se não, é exibido o imóvel de posição zero no array
    if (imovelFiltrado != '') {
      imovelExibido = imovelFiltrado;
    } else {
      imovelExibido = home;
    }

    // DADOS DO EMPREENDIMENTO e imagens da obra
    if (imovelExibido[0] != undefined) {
      setDataUltimaAtualizacaoFotos(
        imovelExibido[0].empreendimento.DataUltimaAtualizacaoFotos ||
          'Data indisponível'
      );

      setDataFotoTirada(imovelExibido[0].empreendimento.DataFotoTirada || '');

      montaStatusDaObra(imovelExibido);

      imagensDaObra(imovelExibido[0].empreendimento.imagens);
    }
  };

  const updateImagesUrl = useCallback(async (imageIndex, imagens) => {
    const currentImages = [...imagens];

    let totalImagesToUpdate = 5;

    let currentImageIndex = imageIndex;

    const idAwsToUpdate = [];

    if (currentImages.length < 5) {
      totalImagesToUpdate = currentImages.length - imageIndex;
    }

    for (let i = 0; i < totalImagesToUpdate; i++) {
      if (
        currentImages[currentImageIndex].idAws &&
        !currentImages[currentImageIndex].imageUrlUpdated
      ) {
        idAwsToUpdate.push(
          getUrlFotoS3(currentImages[currentImageIndex].idAws)
        );
      }
      currentImageIndex++;
    }

    console.log('idAwsToUpdate', idAwsToUpdate);

    if (idAwsToUpdate.length > 0) {
      const allPromisesResult = await Promise.all(idAwsToUpdate);

      let currentIdAwsResult = 0;

      totalImagesToUpdate = 5;

      currentImageIndex = imageIndex;

      for (let i = 0; i < totalImagesToUpdate; i++) {
        if (
          currentImages[currentImageIndex].idAws &&
          !currentImages[currentImageIndex].imageUrlUpdated
        ) {
          currentImages[currentImageIndex].Uri =
            allPromisesResult[currentIdAwsResult].data;
          currentImages[currentImageIndex].imageUrlUpdated = true;
          currentIdAwsResult++;
        }
        currentImageIndex++;
      }
    }

    setImagensEmpreendimento(currentImages);
  }, []);

  return (
    <ContextGetData.Provider
      value={{
        buscaDados,
        setImagensEmpreendimento,
        softImportDataHome,
        importDataHome,
        loadHomeInicial,
        atualizaAgendamentosAbertos,
        filtraImovel,
        updateImagesUrl,
        imagensEmpreendimento,
        statusObra,
        data,
        imoveis,
        idConta,
        idSalesForce,
        arrayTermos,
        dataUltimaAtualizacaoFotos,
        home,
        dataFotoTirada,
        contratosRenegociacao,
      }}
    >
      {children}
    </ContextGetData.Provider>
  );
}

export { GetData, ContextGetData };
